import { useEffect } from 'react';

import { useListEaiControlledDeviceIds } from '@/hooks/query-hooks/gaia-api/scheduled-apps';
import { useCurrentFacility } from '@/hooks/use-current-facility';
import { jotaiStore } from '@/providers/jotai/jotai-store';
import { eaiControlledDeviceIdsAtom } from '@/state/eai-controlled-device-ids.state';

/**
 * Keeps EAI-controlled device IDs synchronized in Jotai for the active agent.
 * Mounted at the `/$org/$agent` route so all child pages share one hydration path.
 */
export const useSyncEaiControlledDeviceIds = () => {
  const { agentId } = useCurrentFacility();
  const { data: eaiControlledDeviceIds } = useListEaiControlledDeviceIds({ agentId });

  useEffect(() => {
    jotaiStore.set(eaiControlledDeviceIdsAtom, eaiControlledDeviceIds);
  }, [eaiControlledDeviceIds]);
};
